<template>
  <div class="card note-wrap private-attach-wrap">
    <div class="header">
      <div class="meta">
        <div class="private-attach-grid">
          <all-bubble
            v-for="attachment in privateAttachments"
            :key="attachment.id"
            :file="attachment"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AllBubble from '../../components/AllBubble.vue';

export default {
  components: {
    AllBubble,
  },
  props: {
    contactId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      privateAttachments: [],
    };
  },
  mounted() {
    this.fetchPrivateAttachments();
  },
  methods: {
    async fetchPrivateAttachments() {
      const { contactId: id } = this;
      this.privateAttachments = await this.$store.dispatch(
        'contacts/privateAttachments',
        { id }
      );
    },
  },
};
</script>

<style lang="scss">
.private-attach-wrap {
  .file--icon {
    color: var(--w-400);
  }
  .meta {
    .text-block-title {
      color: black;
    }

    h5 {
      font-size: 10px;
    }
    .download {
      color: var(--w-400);
    }
  }
  .private-attach-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    column-gap: 8px;
    align-items: center;
  }
  .modal-container {
    img {
      width: 500px !important;
    }

    .modal--close {
      z-index: 2;
    }
  }
  .video .modal-container {
    width: auto;
    max-width: 90vw;

    video {
      display: block;
      max-width: 90vw;
      max-height: 85vh;
      object-fit: contain;
    }
  }
  .location .meta {
    width: 100px;
  }
  .message-text__wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }
  .video.message-text__wrap,
  .image.message-text__wrap {
    height: 62px;
    margin: 4px 0;

    > video,
    > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border: 1px solid theme('colors.gray.200');
      border-radius: 12px;
    }
  }
}
</style>
